
import { Component, OnInit } from '@angular/core';
import { ISystemDetails, SystemDetails } from './system-details';
import { SystemDetailsRetriever as SystemDetailsRepository } from './system-details-retriever.service';
import { ApiResponse } from '../../models/api-response';
import { NotificationService } from "../../services/notification.service";

@Component({
    selector: "mainsystemdetails",
    template: require("./system-details-retriever.component.html")
})
export class SystemDetailsComponent implements OnInit {
    systemGuid: string;
    systemId: string;
    systemIdBase64Encoded: string;
    systemType: string;
    ownershipCode: string;
    user: string;
    responseData: any;

    isSystemRetrieved: boolean = false;

    retrievedSystemDetails: ISystemDetails = new SystemDetails('', '', '', '', '');
    systems: ISystemDetails[];
    guidValidatorRegex: RegExp = new RegExp('^[{(]?[0-9A-Fa-f]{8}[-]?([0-9A-Fa-f]{4}[-]?){3}[0-9A-Fa-f]{12}[)}]?$');

    constructor(private systemDetailsRepo: SystemDetailsRepository,
        private notifier: NotificationService) {
        this.notifier.clear();
    }

    ngOnInit(): void {
    }

    typeCastResponse(response: any): ISystemDetails {

        if (response.statusCode === 200) {
            this.isSystemRetrieved = true;
            var retrievedSystemDetails = (<ISystemDetails>(<ApiResponse>(response)).data);
            return retrievedSystemDetails;

        }
        this.notifier.displayError(response.data.value);
        return new SystemDetails('', '', '', '', '');
    }

    getSystemDetailsByGuid() {
        this.isSystemRetrieved = false;

        if (!this.guidValidatorRegex.test(this.systemGuid)) {
            this.notifier.displayError("Please enter a valid Guid");
            return;
        }
        this.notifier.displayInfo("Fetching system details..");
        this.systemDetailsRepo.getSystemDetailsByGuid(this.systemGuid).subscribe(
            resp => {
                this.responseData = resp;
                if (this.responseData)
                    this.retrievedSystemDetails = this.typeCastResponse(this.responseData);

                this.notifier.clear();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            });
    }

    getSystemDetailsBySystemTypeAndId() {
        this.isSystemRetrieved = false;

        if (this.systemType == null || this.systemId == null || this.systemType === '' || this.systemId === '') {
            this.notifier.displayError("Please enter a valid System Type and Id");
            return;
        }
        this.notifier.displayInfo("Fetching system details..");
        this.systemIdBase64Encoded = this.encodeToBase64(this.systemId);

        this.systemDetailsRepo.getSystemDetailsBySystemTypeAndId(this.systemType, this.systemIdBase64Encoded).subscribe(
            resp => {
                this.responseData = resp;
                this.retrievedSystemDetails = this.typeCastResponse(this.responseData);
                this.notifier.clear();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            });
    }

    getSystemDetailsBySystemTypeAndOwnershipCode() {
        this.isSystemRetrieved = false;
        if (this.systemType == null || this.ownershipCode == null || this.systemType === '' || this.ownershipCode === '') {
            this.notifier.displayError("Please enter a valid System Type and OwnershipCode");
            return;
        }
        this.notifier.displayInfo("Fetching system details..");
        this.systemIdBase64Encoded = this.encodeToBase64(this.systemId);

        this.systemDetailsRepo.getSystemDetailsBySystemTypeAndOwnershipCode(this.systemType, this.ownershipCode).subscribe(
            resp => {
                this.responseData = resp;
                this.retrievedSystemDetails = this.typeCastResponse(this.responseData);
                this.notifier.clear();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            });
    }

    initializeCurrentTab() {
        this.notifier.clear();
        this.retrievedSystemDetails = new SystemDetails('', '', '', '', '');
        this.isSystemRetrieved = false;
    }

    encodeToBase64(id: string) {
        return btoa(id);
    }
}


/** WEBPACK FOOTER **
 ** ./app/main/systemDetailsRetriever/system-details-retriever.component.ts
 **/